import { useProjectApi } from "~/api/GeneratedApi";
import { useCustomQuery } from "~/utils/hooks/useCustomQuery";

export const useGetWPRTemplateList = () => {
  const { getWPRTemplateList } = useProjectApi();

  const { data: wprTemplates } = useCustomQuery(
    "wpr-template-list",
    getWPRTemplateList,
  );

  return { wprTemplates };
};
